export default [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
];
